export default "__VITE_ASSET__B8ozB4HZ__"